module.exports = __webpack_public_path__ + "images/amazonlogo.jpg?4526a";